import { type Dispatch, type MouseEvent, useCallback } from 'react'
import type { LocationEditorActions } from '../types'

export function useLocationEditorListItemProps(dispatch: Dispatch<LocationEditorActions>) {
  const onClick = useCallback(
    (e: MouseEvent<HTMLLIElement>) => {
      const assetId = e.currentTarget.getAttribute('data-asset-id')
      if (!assetId) {
        console.warn('assetId not found')
        return
      }

      dispatch({ type: 'assetListItem:click', assetId })
    },
    [dispatch],
  )

  return {
    onClick,
  }
}
